// import * as React from 'react';
// import PropTypes from 'prop-types';
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Box from '@mui/material/Box';
// import TabTable1 from './TabTable1.js';
// import TabTable2 from './TabTable2.js';
// import TabTable3 from './TabTable3.js';

// // CustomTabPanel component to handle tab content
// function CustomTabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// CustomTabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.number.isRequired,
//   value: PropTypes.number.isRequired,
// };

// // Accessibility props for the tabs
// function a11yProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   };
// }

// // Main component to render the tabs
// export default function TabsComponent() {
//   const [value, setValue] = React.useState(0);

//   const handleChange = (event, newValue) => {
//     setValue(newValue);
//   };

//   return (
//     <Box sx={{ width: '100%' }}>
//       <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
//         <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
//           <Tab label="Payments" {...a11yProps(0)} />
//           <Tab label="Documents" {...a11yProps(1)} />
//           <Tab label="Mark Sheet" {...a11yProps(2)} />
//         </Tabs>
//       </Box>
//       <CustomTabPanel value={value} index={0}>
//       <TabTable1/>
//       </CustomTabPanel>
//       <CustomTabPanel value={value} index={1}>
//         <TabTable2/>
//       </CustomTabPanel>
//       <CustomTabPanel value={value} index={2}>
//       <TabTable3/>
//       </CustomTabPanel>
//     </Box>
//   );
// }

import * as React from 'react';
import PropTypes from 'prop-types';
import { Nav, Tab } from 'react-bootstrap';
import TabTable1 from './TabTable1.js';
import TabTable2 from './TabTable2.js';
import TabTable3 from './TabTable3.js';

function TabsComponent({paymentForms,marksForms,uploads}) {
  return (
    <Tab.Container defaultActiveKey="payments">
      <Nav variant="tabs" className='tbcnt'>
        <Nav.Item>
          <Nav.Link eventKey="payments">Payments</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="mark-sheet">Mark Sheet</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content className='tbcnt'>
        <Tab.Pane eventKey="payments">
          <TabTable1 paymentForms={paymentForms}/>
        </Tab.Pane>
        <Tab.Pane eventKey="documents">
          <TabTable2 uploads={uploads}/>
        </Tab.Pane>
        <Tab.Pane eventKey="mark-sheet">
          <TabTable3 marksForms={marksForms}/>
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
}

TabsComponent.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number,
};

export default TabsComponent;
